import { TitleCasePipe, DatePipe } from '@angular/common';
import { Alert } from './../../classes/Alert';
import { BaseComponent } from './../base/base.component';
import { Component, OnInit } from '@angular/core';
declare var bootbox:any;
declare var $:any;
@Component({
  selector: 'app-distributed-survey-view',
  template: require('./distributed-survey-view.component.html')
})
export class DistributedSurveyViewComponent extends BaseComponent implements OnInit {
  public surveyId = -1;
  public survey = {
    title: ""
  };

  public batchNumber = "";

  public dSurvey = {
    suspendedSurvey:0,
    questionCount:0,
    title:"",
    organization: {
      contactPersonName:"",
      contactPersonPhone:"",
      name:"",
      address:""
    },
    manager: {
    employeeId: -1,
      firstname: "",
      lastname: "",
      department: {
        name:""
      }
    },
    employeesDetails: []
  };

  public pendingEmployeesDetails = [];

  ngOnInit() {
    super.ngOnInit();
  }

  public getFlaggedAnswer(employee) {
      return "All answers are the same (" + employee.flaggedAnswer + ")";
  }

  public addSelectedEmployeesToSurvey() {
      var ids = "";
      $('.slave:checkbox:checked').each(function(index, element){
        ids += "," + $(element).val();
      });
      if(ids.length>0) {
          ids = ids.substr(1);
      }
      this.busy = this.lsApi.addEmployeesToSurvey(ids, this.batchNumber).subscribe(resp => {
            if(resp.status) {
                this.appToast.success("Employees Successfully Added","Employees Added")
            }
        },
        error => {
            console.log(error);
        });
  }

  public addEmployee(employee) {
      $("#throbber_" + employee.employeeId).removeClass("d-none");
      $("#anchor_" + employee.employeeId).addClass("d-none");
    this.busy = this.lsApi.addEmployeesToSurvey(employee.employeeId + "", this.batchNumber).subscribe(resp => {
        if(resp.status) {
            $("#throbber_" + employee.employeeId).addClass("d-none");
            this.appToast.success("Employee Successfully Added","Employee Added")
        }
        else{
      $("#throbber_" + employee.employeeId).addClass("d-none");
      $("#anchor_" + employee.employeeId).removeClass("d-none");
        }
    },
    error => {
        console.log(error);
    });
  }

  public toggleSelectionOfAllPendingEmps() {
      $(".slave").prop('checked', $(".master").prop('checked'));
  }


  public routeParamsUpdated() {
    this.surveyId = this.default(this.currentRouteParams["surveyId"],-1);
    this.batchNumber = this.default(this.currentRouteParams["dId"],"");
    if(this.surveyId>0)
      this.loadSurveyById();
    else 
      this.surveyId = -1;
  }

  public loadSurveyById() {
    this.busy = this.lsApi.getSurveyById(this.surveyId).subscribe(resp => {
        if(resp.status) {
            this.survey = resp.data[0];
            this.loadDistributedSurveyByBatchNumber();
        }
    },
    error => {
        console.log(error);
    });
  }

  public datePipeEn: DatePipe = new DatePipe('en-US')
  public getEmailStats(employee) {
      var emails = employee.emailRecords;
      if(emails!=null && emails.length>0) {
                
            var lastEmailSent = emails[emails.length-1];
            if(lastEmailSent == null) {
                return "N/A";
            }
            else {
                var str = "";
                var status = lastEmailSent.mailgunEmailStatues[lastEmailSent.mailgunEmailStatues.length-1];
                var statusDate = this.datePipeEn.transform(status.dateOccured,"dd MMM, yyyy");
                var titleCase = new TitleCasePipe();
                str = titleCase.transform(lastEmailSent.emailType) + '<i class="unqiueBtn la la-eye"></i>' + "<br>" + titleCase.transform(status.status) + " - <span title='" + this.datePipeEn.transform(status.dateOccured,"dd MMM, yyyy h:mm:ss a z") + "'>" + statusDate + "</span>"
                return str;
            }

        }
        else {
            return "N/A";
        }
  }

public selectedEmployee = {
    employeeId: -1,
    firstname: "",
    lastname: "",
    email:"",
    emailRecords: []
};
  public openEmailDetails(employee) {
      if(employee.emailRecords == null || employee.emailRecords.length <= 0) {
          bootbox.alert("No email records found.");
          return;
      }
    this.selectedEmployee = employee;
    $("#employeeEmailDetails").modal('show');
  }

  public loadDistributedSurveyByBatchNumber() {
    this.busy = this.lsApi.getDistributedSurveyBatchNumber(this.batchNumber).subscribe(resp => {
        if(resp.status) {
            this.dSurvey = resp.data[0];
            this.loadPendingEmployeesByBatchNumber();
        }
    },
    error => {
        console.log(error);
    });
  }

  public loadPendingEmployeesByBatchNumber() {
    this.busy = this.lsApi.getPendingSurveyEmployeeByBatchNumber(this.batchNumber).subscribe(resp => {
        if(resp.status) {
            this.pendingEmployeesDetails = resp.data;
        }
    },
    error => {
        console.log(error);
    });
  }

  public getManagerBadge(employee) { 
      if(employee.employeeId == this.dSurvey.manager.employeeId)
        return '<span class="m-badge m-badge--wide m-badge--rounded m-badge--info">Manager</span>';
      else {
          return '';
      }
  }

  public trashSubmittedSurvey(employee) {

    bootbox.confirm({message:"Do you want to delete " + employee.firstname + "'s submitted survey?",
    buttons: {
        confirm: {
            label: 'Yes',
            className: 'btn-primary'
        },
        cancel: {
            label: 'No',
            className: 'btn-primary btn-simple'
        }
    },
    callback: (result) => {
        if(result) {

              this.busy = this.lsApi.deleteDistributedSurveyById(employee.distributedSurveyId).subscribe(resp => {
                if(resp.status) {
                    this.loadDistributedSurveyByBatchNumber();
                }
            },
            error => {
                console.log(error);
            });

        }
      }});
  }

  public stopSurvey(survey) {


    bootbox.confirm({message:"Do you want to stop " + survey.firstname + "'s survey?",
    buttons: {
        confirm: {
            label: 'Yes',
            className: 'btn-primary'
        },
        cancel: {
            label: 'No',
            className: 'btn-primary btn-simple'
        }
    },
    callback: (result) => {
        if(result) {

              this.busy = this.lsApi.toggleIgnoreDistributedSurveyById(survey.distributedSurveyId).subscribe(resp => {
                if(resp.status) {
                    this.loadDistributedSurveyByBatchNumber();
                }
            },
            error => {
                console.log(error);
            });

        }
      }});

  }

  public generateReport() {
    this.busy = this.lsApi.generateReportForDistributedSurveyBatchNumber(this.batchNumber).subscribe(resp => {
        if(resp.status) {  
            this.appToast.success("Report Successfully Generated","Report Generated");
            window.location.href = "/resources/survey/report/" + this.lsApp.getCurrentAuthToken() + "/" + this.batchNumber + "/" + resp.data[0], "_blank";
        }
    },
    error => {
        console.log(error);
    });  
  }

  public resendLink(employee) {
    this.busy = this.lsApi.resendLink(this.batchNumber, employee.employeeId).subscribe(resp => {
        if(resp.status) {
            this.appToast.success("Survey Link Successfully Sent via Email","Email Sent");
        }
    },
    error => {
        console.log(error);
    });
  }

  public sendReminder(employee) {
    this.busy = this.lsApi.sendReminder(this.batchNumber, employee.employeeId).subscribe(resp => {
        if(resp.status) {
            this.appToast.success("Survey Link Successfully Sent via Email","Email Sent");
        }
    },
    error => {
        console.log(error);
    });
  }

  public sendSurveyReminders() {
    this.busy = this.lsApi.sendSurveyReminders(this.batchNumber).subscribe(resp => {
        if(resp.status) {
            this.appToast.success("Survey Link Successfully Sent via Email","Email Sent");
        }
    },
    error => {
        console.log(error);
    });
  }

  public resendSurveyLink() {
    this.busy = this.lsApi.resendSurveyLink(this.batchNumber).subscribe(resp => {
        if(resp.status) {
            this.appToast.success("Survey Link Successfully Sent via Email","Email Sent");
        }
    },
    error => {
        console.log(error);
    });

  }

  public stopBatchSurvey() {

    if(this.dSurvey.suspendedSurvey==1) {
      bootbox.alert("Survey has already been stopped");
      return;
    }


    bootbox.confirm({message:"Do you want to stop all " + this.dSurvey.employeesDetails.length + " surveys?",
    buttons: {
        confirm: {
            label: 'Yes',
            className: 'btn-primary'
        },
        cancel: {
            label: 'No',
            className: 'btn-primary btn-simple'
        }
    },
    callback: (result) => {
        if(result) {

              this.busy = this.lsApi.stopDistributedSurveysByBatchNumber(this.batchNumber).subscribe(resp => {
                if(resp.status) {
                    this.loadDistributedSurveyByBatchNumber();
                }
            },
            error => {
                console.log(error);
            });

        }
      }});

  }


}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/distributed-survey-view/distributed-survey-view.component.ts